module.exports = __webpack_public_path__ + "img/ic_close.8d12f3b1.svg";